import { EventActionType } from './event-action-type';

export interface UpdateEventSuccessAction {
  eventKey: string;
  type: EventActionType.UpdateEventSuccess;
}

export const updateEventSuccess = (
  eventKey: string,
): UpdateEventSuccessAction => ({
  eventKey,
  type: EventActionType.UpdateEventSuccess,
});
